/**
 *
 * Asynchronously loads the component for CompanySettings
 *
 */

import { lazyLoad } from 'utils/loadable';

export const CompanySettings = lazyLoad(
  () => import('./index'),
  module => module.CompanySettings,
);
